import { z } from 'zod'
import { ProductPrice } from './ProductPrice'
import { ProductStatus } from './ProductStatus'
import { PaymentInterval } from '@/types/purchase/PaymentInterval'

export const Product = z.object({
  name: z.string(),
  description: z.string().optional().default(''),
  slug: z.string().optional(),
  features: z.record(z.string(), z.any()).optional(),
  price: ProductPrice.array().optional(),
  payment_interval: PaymentInterval.array().optional(),
  status: ProductStatus.optional(),
  active: z.boolean().optional().default(true), // Archive function
  public: z.boolean().optional().default(true), // Sichtbar oder nicht
  immutable: z.boolean().optional()
  // type: z.string()
})

export type Product = z.infer<typeof Product>

// TODO: extract type from features
